export default __webpack_public_path__ + "static/media/undraw_error.4d413a1d.svg";